const APPLICATION_ID = 'p4app';
const TOGGLE_MENU = 'app/TOGGLE_MENU';
const USER_REQUEST = 'app/USER_REQUEST';
const USER_SUCCESS = 'app/USER_SUCCESS';
const USER_FAILURE = 'app/USER_FAILURE';
const MODAL_USER_REQUEST = 'app/MODAL_USER_REQUEST';
const MODAL_USER_SUCCESS = 'app/MODAL_USER_SUCCESS';
const MODAL_USER_FAILURE = 'app/MODAL_USER_FAILURE';
const VERSION_REQUEST = 'app/VERSION_REQUEST';
const VERSION_SUCCESS = 'app/VERSION_SUCCESS';
const VERSION_FAILURE = 'app/VERSION_FAILURE';
const REQUEST_PASSWORD_RESET_REQUEST = 'app/REQUEST_PASSWORD_RESET_REQUEST';
const REQUEST_PASSWORD_RESET_SUCCESS = 'app/REQUEST_PASSWORD_RESET_SUCCESS';
const REQUEST_PASSWORD_RESET_FAILURE = 'app/REQUEST_PASSWORD_RESET_FAILURE';
const PASSWORD_RESET_REQUEST = 'app/PASSWORD_RESET_REQUEST';
const PASSWORD_RESET_SUCCESS = 'app/PASSWORD_RESET_SUCCESS';
const PASSWORD_RESET_FAILURE = 'app/PASSWORD_RESET_FAILURE';
const SWITCH_COMPANY_REQUEST = 'app/SWITCH_COMPANY_REQUEST';
const SWITCH_COMPANY_SUCCESS = 'app/SWITCH_COMPANY_SUCCESS';
const SWITCH_COMPANY_FAILURE = 'app/SWITCH_COMPANY_FAILURE';
const LOGIN_REDIRECT = 'app/LOGIN_REDIRECT';
const LOGOUT_USER_REQUEST = 'app/LOGOUT_USER_REQUEST';
const LOGOUT_USER_SUCCESS = 'app/LOGOUT_USER_SUCCESS';
const LOGOUT_USER_FAILURE = 'app/LOGOUT_USER_FAILURE';
const DISMISS_AUTH_ALERT = 'app/DISMISS_AUTH_ALERT';
const FOCUS_AREA = 'app/FOCUS_AREA';
const SET_ACTION_ENTITIES = 'app/SET_ACTION_ENTITIES';
const SET_EXPANDED_ROW = 'app/SET_EXPANDED_ROW';
const SET_EXPANDED_ROWS = 'app/SET_EXPANDED_ROWS';
const PROMPT = 'app/PROMPT';
const CLOSE_PROMPT = 'app/CLOSE_PROMPT';
const START_JOB = 'app/START_JOB';
const BACKGROUND_JOB = 'app/BACKGROUND_JOB';
const UPDATE_JOB = 'app/UPDATE_JOB';
const COMPLETE_JOB = 'app/COMPLETE_JOB';
const FAIL_JOB = 'app/FAIL_JOB';
const REQUEST_JOB = 'app/REQUEST_JOB';
const STORE_URL = 'app/STORE_URL';
const UPLOAD_IMAGE_REQUEST = 'app/UPLOAD_IMAGE';
const UPLOAD_IMAGE_SUCCESS = 'app/UPLOAD_IMAGE_SUCCESS';
const UPLOAD_IMAGE_FAILURE = 'app/UPLOAD_IMAGE_FAILURE';
const UPLOAD_DOCUMENT_REQUEST = 'app/UPLOAD_DOCUMENT';
const UPLOAD_DOCUMENT_SUCCESS = 'app/UPLOAD_DOCUMENT_SUCCESS';
const UPLOAD_DOCUMENT_FAILURE = 'app/UPLOAD_DOCUMENT_FAILURE';
const UPLOAD_FILE_REQUEST = 'app/UPLOAD_IMAGE';
const UPLOAD_FILE_SUCCESS = 'app/UPLOAD_IMAGE_SUCCESS';
const UPLOAD_FILE_FAILURE = 'app/UPLOAD_IMAGE_FAILURE';
const MENU_UPDATE_REQUEST = 'app/MENU_UPDATE_REQUEST';
const MENU_UPDATE_SUCCESS = 'app/MENU_UPDATE_SUCCESS';
const MENU_UPDATE_FAILURE = 'app/MENU_UPDATE_FAILURE';
const CLEAR_LOGIN = 'app/CLEAR_LOGIN';
const TOGGLE_FULL_SCREEN = 'app/TOGGLE_FULL_SCREEN';
const TOGGLE_SIDEBAR = 'app/TOGGLE_SIDEBAR';
const TOGGLE_MAIL_SIDEBAR = 'app/TOGGLE_MAIL_SIDEBAR';

export default {
  APPLICATION_ID,
  TOGGLE_MENU,
  USER_REQUEST,
  USER_SUCCESS,
  USER_FAILURE,
  VERSION_REQUEST,
  VERSION_SUCCESS,
  VERSION_FAILURE,
  REQUEST_PASSWORD_RESET_REQUEST,
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET_FAILURE,
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAILURE,
  SWITCH_COMPANY_REQUEST,
  SWITCH_COMPANY_SUCCESS,
  SWITCH_COMPANY_FAILURE,
  LOGIN_REDIRECT,
  LOGOUT_USER_REQUEST,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
  DISMISS_AUTH_ALERT,
  FOCUS_AREA,
  SET_ACTION_ENTITIES,
  SET_EXPANDED_ROW,
  SET_EXPANDED_ROWS,
  PROMPT,
  CLOSE_PROMPT,
  START_JOB,
  BACKGROUND_JOB,
  UPDATE_JOB,
  COMPLETE_JOB,
  FAIL_JOB,
  REQUEST_JOB,
  STORE_URL,
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  UPLOAD_DOCUMENT_REQUEST,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  MENU_UPDATE_REQUEST,
  MENU_UPDATE_SUCCESS,
  MENU_UPDATE_FAILURE,
  MODAL_USER_REQUEST,
  MODAL_USER_SUCCESS,
  MODAL_USER_FAILURE,
  CLEAR_LOGIN,
  TOGGLE_FULL_SCREEN,
  TOGGLE_SIDEBAR,
  TOGGLE_MAIL_SIDEBAR,
};
